import * as EVENTS from './events';
import * as CONTENT_TYPES from './content-types';
import { createTargetFromVideo } from '#/lib/et/target-factory.js';
import { closeSession, startSession } from './tracker.js';

export default ET;
export { EVENTS, CONTENT_TYPES };

function ET({ root, hostGateway }) {
  const tracker = {
    push([event, payload]) {
      if (import.meta.env.DEV) {
        console.groupCollapsed(`%cET: ${event}`, 'background-color: orange; font-weight: bold');
        console.log(JSON.stringify(payload, null, 1));
        console.groupEnd();
      }
      hostGateway.trackEvent(event, payload);
    }
  }
  return {
    start() {
      startSession(root, tracker);
    },
    stop() {
      closeSession();
    },
    setTarget(currentObject) {
      const target = createTargetFromVideo(currentObject);
      root.dataset.etTarget = JSON.stringify(target);
    },
  };
}

/**
 * @namespace ET
 */

/**
 * @typedef {Object} ETInterface
 *
 * @property {(target: ET.Target) => void} startSession
 * @property {() => void} closeSession
 * @property {(event: *, context: *) => void} track
 */

/**
 * @typedef {Object} ET.Feed
 *
 * @property {string} type
 * @property {string} algorithm
 * @property {number} id based on code?
 * @property {string} code
 * @property {string} [title='']
 * @property {[{id: number, type: "landing", position: number}]}  objects_extended
 */

/**
 * @typedef {Object} ET.UI
 *
 * @property {"image"|"button"|"close"} element_type
 * @property {string} element_code
 * @property {string} [element_text='']
 */


/**
 *
 * @typedef {Object} ET.VideoTarget
 *
 * @property {ET.ContentType} object_type Тип объекта на интерактиве
 * @property {number} object_id hash(object_code) || object_id
 * @property {string} [object_title=""] Title of the object, is present almost never
 * @property {string} [virtual_object_id]
 */

/**
 *
 * @typedef {ET.VideoTarget} ET.CampaignTarget
 *
 * @property {"CAMPAIGN"} object_type "CAMPAIGN", // Тип объекта на интерактиве
 * @property {number} object_id hash(campaign_id), // хеш ID  кампании
 * @property {string} object_code campaign_id
 */

/**
 * @typedef {Object} ET.TrackingEvent
 *
 * @property {string} event Client's event
 * @property {string} target ID of element having tracking event
 * @property {string} trackName
 * @property {{feed: ET.Feed, ui?: ET.UI}} payload
 *
 */
